module.exports = __webpack_public_path__ + "img/Shiba-BG.e5a02ec6.jpg";